import React from 'react';
import { Link } from 'react-router-dom';
import StaticSeo from '../components/StaticSeo.jsx';

export default function NotFound() {
  const T = {
    bg: '#F4F1EA', surface: '#FAF7F1', ink: '#1A1D1C',
    inkSoft: '#5A5A52', inkFaint: '#A39E91', rule: '#D9D3C5',
    sienna: '#B5532A',
  };
  const fontDisplay = "'Fraunces', serif";
  const fontMono = "'JetBrains Mono', monospace";

  return (
    <div style={{
      minHeight: '100vh', background: T.bg, color: T.ink,
      display: 'flex', flexDirection: 'column',
      padding: 24,
    }}>
      <StaticSeo path="/404" noindex />
      <Link to="/" style={{
        fontFamily: fontDisplay, fontSize: 22,
        color: T.ink, textDecoration: 'none',
        paddingBottom: 16,
        borderBottom: `1px solid ${T.rule}`,
      }}>
        Window Washing <em style={{ fontStyle: 'italic' }}>Guide</em>
      </Link>

      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        justifyContent: 'center', maxWidth: 720, margin: '0 auto',
        padding: '40px 0',
      }}>
        <div style={{
          fontFamily: fontMono, fontSize: 11,
          letterSpacing: '0.18em', color: T.sienna,
          marginBottom: 20,
        }}>
          ◆ ERROR · 404
        </div>

        <h1 style={{
          fontFamily: fontDisplay, fontSize: 64, fontWeight: 400,
          lineHeight: 1.05, letterSpacing: '-0.025em',
          margin: '0 0 24px',
        }}>
          A pane that doesn't <em style={{ fontStyle: 'italic', color: T.inkSoft, fontWeight: 400 }}>exist</em>.
        </h1>

        <p style={{
          fontFamily: fontDisplay, fontSize: 20, fontWeight: 300,
          lineHeight: 1.55, color: T.inkSoft,
          margin: '0 0 40px',
          maxWidth: 520,
        }}>
          You looked for a window we haven't installed yet. Either the URL is wrong, or this page is on the editorial calendar but not yet published. Either way, the homepage is a better place to be.
        </p>

        <div>
          <Link to="/" style={{
            fontFamily: fontMono, fontSize: 11,
            letterSpacing: '0.18em', color: T.ink,
            border: `1px solid ${T.ink}`,
            padding: '14px 28px',
            textDecoration: 'none',
            display: 'inline-block',
          }}>
            ← BACK TO HOMEPAGE
          </Link>
        </div>
      </div>

      <div style={{
        paddingTop: 24, borderTop: `1px solid ${T.rule}`,
        fontFamily: fontMono, fontSize: 11,
        letterSpacing: '0.1em', color: T.inkFaint,
        display: 'flex', justifyContent: 'space-between',
      }}>
        <span>NO. 042 · ERROR PAGE</span>
        <span>Made with patience · Built for the long haul</span>
      </div>
    </div>
  );
}
